import React from "react";
import type { ProjectAccess } from "./api";

type ProjectAccessCtxValue = {
    access: ProjectAccess | null;
    isLoading: boolean;
}

const ProjectAccessCtx = React.createContext<ProjectAccessCtxValue>({
    access: null,
    isLoading: true,
});

export function ProjectAccessProvider({
    access,
    isLoading,
    children,
}: React.PropsWithChildren<ProjectAccessCtxValue>) {
    return <ProjectAccessCtx.Provider value={{ access, isLoading }}>{children}</ProjectAccessCtx.Provider>
}

export function useProjectAccessCtx() {
    return React.useContext(ProjectAccessCtx)
}
